import { SimplePersonFormModel } from './model'

export const initialValues: SimplePersonFormModel = {
	name: '',
	email: '',
	phone: '',
}
